import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroBullets, PRECIO_LARGO } from '../data/content';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-cream" data-id="element-62" data-mp="9kjvumdkz02m">
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 items-center gap-10 px-5 pb-12 pt-10 sm:px-8 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14 lg:pb-20 lg:pt-16" data-id="element-63" data-mp="9ipbpaa4vbzl">
        <div data-id="element-64" data-mp="12860lxyjoar2">
          <p className="mb-5 inline-flex items-center gap-2 rounded-full bg-verde-soft px-3 py-1.5 font-mono text-[11px] font-bold uppercase tracking-widest text-verde-dark" data-id="element-65" data-mp="128z14h6wu40r">
            <ZapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-66" data-mp="sa9rtct2xrw4" />
            Producto digital · Argentina
          </p>

          <h1 className="font-display text-[2.1rem] font-extrabold leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-[3.4rem]" style={{
          fontSize: "28px",
          textAlign: "center"
        }} data-id="element-67" data-mp="nbonb16som1v">
            ¿Otra vez saliste del súper pensando{' '}
            <span className="relative inline-block" data-id="element-68" data-mp="3j8sdfvbir9n7">
              <span className="relative z-10" data-id="element-69" data-mp="3j923tk0h7itf">“cómo gasté tanto”</span>
              <span className="absolute inset-x-[-4px] bottom-[0.08em] z-0 h-[0.42em] bg-amarillo" aria-hidden="true" data-id="element-70" data-mp="3o7vl7nivvtyv" />
            </span>
            ?
          </h1>

          <p className="mt-5 max-w-xl text-lg leading-relaxed text-ink-soft sm:text-xl" style={{
          fontSize: "14px"
        }} data-id="element-71" data-mp="3e9fpt8ctpyjk">
            Aprendé un sistema simple para organizar descuentos, reintegros y compras semanales, y
            hacer que tu plata rinda más <strong className="font-semibold text-ink" data-id="element-72" data-mp="359javyg8ke1p">sin vivir privándote</strong>.
          </p>

          <img src="https://cdn.magicpatterns.com/patterns/generated-images/38a0cb69-4765-45b1-a8cf-0c0ca6d7462a.jpg" alt="Persona revisando un ticket largo en la caja del supermercado" className="aspect-[4/5] w-full rounded-2xl object-cover shadow-card" loading="eager" width={928} height={1160} style={{
          width: "320px",
          height: "192px"
        }} data-id="element-73" data-mp="2ql69un2ak50c" /><ul className="mt-6 grid grid-cols-1 gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-74" data-mp="2lmuyu909fogj">
            {heroBullets.map(b => <li key={b} className="flex items-start gap-2.5 text-[15px] font-medium text-ink" data-id="element-75" data-mp="s3uqvwnx98am">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-verde" aria-hidden="true" data-id="element-76" data-mp="n9i3xcn8leu4" />
                {b}
              </li>)}
          </ul>

          <div className="mt-8 max-w-md" data-id="element-77" data-mp="de6o0r03e1ks">
            <CtaButton label="Quiero hacer rendir más mi plata" data-id="element-78" data-mp="db2dlbw1a9lo" />
            <div className="mt-3 flex flex-wrap items-baseline justify-center gap-x-3 gap-y-1 text-center" data-id="element-79" data-mp="1azku1n7lcaq3">
              <span className="font-mono text-xl font-bold text-ink" data-id="element-80" data-mp="162c9xh2vtwm7">{PRECIO_LARGO}</span>
              <span className="text-sm text-ink-muted" data-id="element-81" data-mp="111es55lsb4l8">Pago único · Acceso digital inmediato</span>
            </div>
          </div>
        </div>

        <div className="relative" data-id="element-82" data-mp="x3h6gcr830ml">
          

          
        </div>
      </div>
    </header>;
}